<template>
    <div>
        <base-crud
                crudName="Equipamentos"
                newText="Novo Equipamento"
                :table="equipmentTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="false"
                :enableDelete="false"
                :enableView="false"
                :enableSetStatus="true"
        >
        </base-crud>

    </div>
</template>

<script>

    import BaseCrud from '../Base/BaseCrud'

    export default {

        data: function () {
            return {
                equipmentTable: 'equipmentTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'equipment_id', 'description', 'status', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'equipment_id', 'description', 'status'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        'equipment_id': 'Equipamento',
                        'description': 'Descrição',
                        'actions': 'Ações'
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: 'equipment/'
            }
        },
        components: {
            BaseCrud
        }

    }
</script>

<style>

    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Equipment/Crud.vue